import React from "react";
import { Loader2 } from "lucide-react";

export function FullPageSpinner() {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-offwhite"
      data-testid="full-page-spinner"
    >
      <Loader2 className="h-6 w-6 animate-spin text-taupe" />
    </div>
  );
}
